module.exports = __webpack_public_path__ + "static/img/slip_stehend2.ded10851.png";